var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5372",
    "data-name": "Group 5372",
    transform: "translate(-1768.5 -320)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1927",
    "data-name": "Rectangle 1927",
    width: 50,
    height: 50,
    rx: 5,
    transform: "translate(1768.5 320)",
    fill: "#e23744",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-small-left",
    d: "M32.443,23.87a1.429,1.429,0,0,1,2.014-2.029l6.129,6.143A2.857,2.857,0,0,1,41.428,30h0a2.857,2.857,0,0,1-.843,2l-6.129,6.143a1.429,1.429,0,0,1-2.014-2.029L37.946,30Z",
    transform: "translate(1823.056 307.98) rotate(90)",
    fill: "#e23744"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqClose);
export default __webpack_public_path__ + "static/media/faqClose.7c733a2f012f5166f8a4417333214758.svg";
export { ForwardRef as ReactComponent };